module.exports = __webpack_public_path__ + "img/icon-quanta-shop-branco.5765b47f.png";